import * as d3 from 'd3';
import * as _ from 'lodash';

import { Crosshair } from '../pieces/Crosshair';
import { Legend } from '../pieces/Legend';
import { IPane } from '../pieces/IPane';
import { Pane } from '../pieces/Pane';
import { IChartFactory } from './IChartFactory';
import { SeriesManager } from '../managers/SeriesManager';
import { ILogger, LoggerFactory } from '../../helpers/helpers';
import { TimeScale } from '../pieces/scales/index';
import { VerticalAxis } from '../pieces/axes/index';

export class TimeChart {
    crosshair: Crosshair<Date>;
    group: d3.Selection<any>;
    legend: Legend;
}


export class ChartFactory implements IChartFactory {
    private _logger: ILogger;
    constructor(private _d3: any, private _console: Console) {
        this._logger = LoggerFactory.getLogger('WideTech.Charting.chartFactory');
    }

    createLineChartPane(container: d3.Selection<any>, width: number, height: number): IPane {
        try {
            this._logger.info(`Creating line chart pane (width: ${width}, height: ${height})`);
            const manager = new SeriesManager(_, d3);
            return new Pane(container, manager, width, height);
        } catch (e) {
            this._console.error(e);
        }
    }

    createChartArea(container: d3.Selection<any>, width: number, height: number): d3.Selection<any> {
        const group = container
            .append('g')
            .classed('chart-area', true);
        group.append('rect')
            .attr({
                'x': 0,
                'y': 0,
                'width': width,
                'height': height
            })
            .classed('chart-area-rectangle', true);
        return group;
    }

    createPlotArea(container: d3.Selection<any>, width: number, height: number, left: number, top: number, id: string): d3.Selection<any> {
        const plotAreaGroup = container
            .append('g')
            .attr({
                'transform': 'translate(' + left + ', ' + top + ')'
            })
            .classed('plot-area', true);

        const clipPath = plotAreaGroup
            .append('clipPath')
            .attr({
                'id': id
            });
        clipPath
            .append('rect')
            .attr({
                'x': 0,
                'y': 0,
                width: width,
                height: height
            });

        plotAreaGroup
            .append('rect')
            .classed('plot-area-rectangle', true)
            .attr({
                'x': 0,
                'y': 0,
                'width': width,
                'height': height
            });

        return plotAreaGroup;
    }

    createSeriesGroup(container: d3.Selection<any>, clipPathId: string): d3.Selection<any> {
        return container
            .append('g')
            .classed('series-group', true)
            .style('clip-path', 'url(#' + clipPathId + ')');
    }

    createAxes(container: d3.Selection<any>, width: number, height: number, scale: TimeScale) {

        const axesGroup = container
            .append('g')
            .classed('axes-group', true);
        const yAxisBase = new VerticalAxis(height,
            0, 1, 5, axesGroup);

        const xAxisGroup = container
            .append('g')
            .classed('axis', true)
            .attr({
                'transform': 'translate(0,' + height + ')'
            });
        const xAxis = d3.svg.axis()
            .scale(scale.scale())
            .orient('bottom');
        xAxisGroup.call(xAxis);
    }

    createHorizontalLines(container: d3.Selection<any>): d3.Selection<any> {
        return container
            .append('g')
            .classed('horizontal-lines', true);
    }

    initCrosshair(container, width, height): Crosshair<Date> {
        const crosshairGroup = container
            .append('g')
            .classed('crosshair-group', true);
        return new Crosshair<Date>(width, height, crosshairGroup);
    }

    createGridLines(container: d3.Selection<any>): d3.Selection<any> {
        return container
            .append('g')
            .classed('horizontal-gridlines', true);
    }

    createZoomGroup(container: d3.Selection<any>): d3.Selection<any> {
        const zoomGroup = container
            .append('g')
            .classed('zoom-rectangle', true);
        zoomGroup.append('rect');
        return zoomGroup;
    }
}